var _path, _rect, _rect2, _rect3, _polygon, _polygon2, _polygon3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _polygon4, _rect84, _circle, _polygon5, _polygon6, _polygon7, _rect85, _polygon8, _polygon9, _rect86, _rect87, _rect88, _rect89, _rect90, _rect91, _rect92, _rect93, _rect94, _rect95, _rect96, _rect97, _g, _rect98, _rect99, _rect100, _rect101, _path2, _rect102, _rect103, _rect104, _rect105, _polygon10, _rect106, _rect107, _rect108, _rect109, _rect110, _rect111, _rect112, _rect113, _g2, _g3, _path3, _path4, _path5, _path6, _polygon11, _path7, _path8, _path9, _path10, _path11, _g4, _path12, _path13, _g5, _path14, _path15, _path16, _polygon12, _path17;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMain(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 753 823",
    viewBox: "0 0 753 823",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#cce9ff",
    d: "M650.6,718.6c-3.7,31.8-102.5,40.4-221.4,26.5c-119-13.9-220.7,20.6-217-11.3s105.1-63.2,224.1-49.3 S654.3,686.8,650.6,718.6z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 31.5,
    height: 125.6,
    x: 214.4,
    y: 354.5,
    fill: "#f7f7f7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 21.2,
    height: 52.8,
    x: 219.5,
    y: 345.5,
    fill: "#f7f7f7"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 11.8,
    height: 29.3,
    x: 224.2,
    y: 339.8,
    fill: "#f7f7f7"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#f7f7f7",
    points: "234.1 354.9 226.1 354.9 226.1 334.9 229 334.9 231.9 334.9 234.1 334.9"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#f7f7f7",
    points: "229.6 346.2 228.7 346.2 228.7 326.2 229 326.2 229.4 326.2 229.6 326.2"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#f7f7f7",
    points: "231.5 339.3 230.7 339.3 230.7 319.3 231 319.3 231.3 319.3 231.5 319.3"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 33.2,
    height: 1.3,
    x: 213.5,
    y: 354.2,
    fill: "#f7f7f7"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 22.8,
    height: 1.3,
    x: 218.7,
    y: 344.9,
    fill: "#f7f7f7"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 13.1,
    height: 1,
    x: 223.4,
    y: 339.3,
    fill: "#f7f7f7"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 5.5,
    x: 221.5,
    y: 347.7,
    fill: "#f7f7f7",
    opacity: 0.29
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 5.5,
    x: 224.2,
    y: 347.7,
    fill: "#f7f7f7",
    opacity: 0.29
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 5.5,
    x: 226.9,
    y: 347.7,
    fill: "#f7f7f7",
    opacity: 0.29
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 5.5,
    x: 229.7,
    y: 347.7,
    fill: "#f7f7f7",
    opacity: 0.29
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 5.5,
    x: 232.4,
    y: 347.7,
    fill: "#f7f7f7",
    opacity: 0.29
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 5.5,
    x: 235.1,
    y: 347.7,
    fill: "#f7f7f7",
    opacity: 0.29
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 5.5,
    x: 237.9,
    y: 347.7,
    fill: "#f7f7f7",
    opacity: 0.29
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 2.4,
    height: 6.6,
    x: 217.1,
    y: 359.6,
    fill: "#f7f7f7"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    width: 2.4,
    height: 6.6,
    x: 221.8,
    y: 359.6,
    fill: "#f7f7f7",
    opacity: 0.29
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    width: 2.4,
    height: 6.6,
    x: 226.6,
    y: 359.6,
    fill: "#f7f7f7"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    width: 2.4,
    height: 6.6,
    x: 231.3,
    y: 359.6,
    fill: "#f7f7f7"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    width: 2.4,
    height: 6.6,
    x: 236,
    y: 359.6,
    fill: "#f7f7f7"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    width: 2.4,
    height: 6.6,
    x: 240.7,
    y: 359.6,
    fill: "#f7f7f7"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    width: 2.4,
    height: 6.6,
    x: 217.1,
    y: 369.8,
    fill: "#f7f7f7"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    width: 2.4,
    height: 6.6,
    x: 221.8,
    y: 369.8,
    fill: "#f7f7f7"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    width: 2.4,
    height: 6.6,
    x: 226.6,
    y: 369.8,
    fill: "#f7f7f7"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    width: 2.4,
    height: 6.6,
    x: 231.3,
    y: 369.8,
    fill: "#f7f7f7",
    opacity: 0.29
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    width: 2.4,
    height: 6.6,
    x: 236,
    y: 369.8,
    fill: "#f7f7f7"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    width: 2.4,
    height: 6.6,
    x: 240.7,
    y: 369.8,
    fill: "#f7f7f7"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    width: 2.4,
    height: 6.6,
    x: 217.1,
    y: 380,
    fill: "#f7f7f7"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    width: 2.4,
    height: 6.6,
    x: 221.8,
    y: 380,
    fill: "#f7f7f7"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    width: 2.4,
    height: 6.6,
    x: 226.6,
    y: 380,
    fill: "#f7f7f7"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    width: 2.4,
    height: 6.6,
    x: 231.3,
    y: 380,
    fill: "#f7f7f7"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    width: 2.4,
    height: 6.6,
    x: 236,
    y: 380,
    fill: "#f7f7f7",
    opacity: 0.29
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    width: 2.4,
    height: 6.6,
    x: 240.7,
    y: 380,
    fill: "#f7f7f7",
    opacity: 0.29
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    width: 2.4,
    height: 6.6,
    x: 217.1,
    y: 390.2,
    fill: "#f7f7f7",
    opacity: 0.29
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    width: 2.4,
    height: 6.6,
    x: 221.8,
    y: 390.2,
    fill: "#f7f7f7"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    width: 2.4,
    height: 6.6,
    x: 226.6,
    y: 390.2,
    fill: "#f7f7f7"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    width: 2.4,
    height: 6.6,
    x: 231.3,
    y: 390.2,
    fill: "#f7f7f7"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    width: 2.4,
    height: 6.6,
    x: 236,
    y: 390.2,
    fill: "#f7f7f7"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    width: 2.4,
    height: 6.6,
    x: 240.7,
    y: 390.2,
    fill: "#f7f7f7"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    width: 2.4,
    height: 6.6,
    x: 217.1,
    y: 400.4,
    fill: "#f7f7f7"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    width: 2.4,
    height: 6.6,
    x: 221.8,
    y: 400.4,
    fill: "#f7f7f7",
    opacity: 0.29
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    width: 2.4,
    height: 6.6,
    x: 226.6,
    y: 400.4,
    fill: "#f7f7f7"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    width: 2.4,
    height: 6.6,
    x: 231.3,
    y: 400.4,
    fill: "#f7f7f7",
    opacity: 0.29
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    width: 2.4,
    height: 6.6,
    x: 236,
    y: 400.4,
    fill: "#f7f7f7"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    width: 2.4,
    height: 6.6,
    x: 240.7,
    y: 400.4,
    fill: "#f7f7f7"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    width: 2.4,
    height: 6.6,
    x: 217.1,
    y: 410.7,
    fill: "#f7f7f7"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    width: 2.4,
    height: 6.6,
    x: 221.8,
    y: 410.7,
    fill: "#f7f7f7"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    width: 2.4,
    height: 6.6,
    x: 226.6,
    y: 410.7,
    fill: "#f7f7f7"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    width: 2.4,
    height: 6.6,
    x: 231.3,
    y: 410.7,
    fill: "#f7f7f7"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    width: 2.4,
    height: 6.6,
    x: 236,
    y: 410.7,
    fill: "#f7f7f7"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    width: 2.4,
    height: 6.6,
    x: 240.7,
    y: 410.7,
    fill: "#f7f7f7",
    opacity: 0.29
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    width: 2.4,
    height: 6.6,
    x: 217.1,
    y: 420.9,
    fill: "#f7f7f7"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    width: 2.4,
    height: 6.6,
    x: 221.8,
    y: 420.9,
    fill: "#f7f7f7",
    opacity: 0.29
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    width: 2.4,
    height: 6.6,
    x: 226.6,
    y: 420.9,
    fill: "#f7f7f7",
    opacity: 0.29
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    width: 2.4,
    height: 6.6,
    x: 231.3,
    y: 420.9,
    fill: "#f7f7f7"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    width: 2.4,
    height: 6.6,
    x: 236,
    y: 420.9,
    fill: "#f7f7f7"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    width: 2.4,
    height: 6.6,
    x: 240.7,
    y: 420.9,
    fill: "#f7f7f7"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    width: 2.4,
    height: 6.6,
    x: 217.1,
    y: 431.1,
    fill: "#f7f7f7"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    width: 2.4,
    height: 6.6,
    x: 221.8,
    y: 431.1,
    fill: "#f7f7f7"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    width: 2.4,
    height: 6.6,
    x: 226.6,
    y: 431.1,
    fill: "#f7f7f7"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    width: 2.4,
    height: 6.6,
    x: 231.3,
    y: 431.1,
    fill: "#f7f7f7"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    width: 2.4,
    height: 6.6,
    x: 236,
    y: 431.1,
    fill: "#f7f7f7",
    opacity: 0.29
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    width: 2.4,
    height: 6.6,
    x: 240.7,
    y: 431.1,
    fill: "#f7f7f7"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    width: 2.4,
    height: 6.6,
    x: 217.1,
    y: 441.3,
    fill: "#f7f7f7"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    width: 2.4,
    height: 6.6,
    x: 221.8,
    y: 441.3,
    fill: "#f7f7f7",
    opacity: 0.29
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    width: 2.4,
    height: 6.6,
    x: 226.6,
    y: 441.3,
    fill: "#f7f7f7"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    width: 2.4,
    height: 6.6,
    x: 231.3,
    y: 441.3,
    fill: "#f7f7f7"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    width: 2.4,
    height: 6.6,
    x: 236,
    y: 441.3,
    fill: "#f7f7f7"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    width: 2.4,
    height: 6.6,
    x: 240.7,
    y: 441.3,
    fill: "#f7f7f7"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    width: 2.4,
    height: 6.6,
    x: 217.1,
    y: 451.6,
    fill: "#f7f7f7"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    width: 2.4,
    height: 6.6,
    x: 221.8,
    y: 451.6,
    fill: "#f7f7f7"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    width: 2.4,
    height: 6.6,
    x: 226.6,
    y: 451.6,
    fill: "#f7f7f7"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    width: 2.4,
    height: 6.6,
    x: 231.3,
    y: 451.6,
    fill: "#f7f7f7",
    opacity: 0.29
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    width: 2.4,
    height: 6.6,
    x: 236,
    y: 451.6,
    fill: "#f7f7f7"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    width: 2.4,
    height: 6.6,
    x: 240.7,
    y: 451.6,
    fill: "#f7f7f7",
    opacity: 0.29
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    width: 2.4,
    height: 6.6,
    x: 217.1,
    y: 461.8,
    fill: "#f7f7f7",
    opacity: 0.29
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    width: 2.4,
    height: 6.6,
    x: 221.8,
    y: 461.8,
    fill: "#f7f7f7"
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    width: 2.4,
    height: 6.6,
    x: 226.6,
    y: 461.8,
    fill: "#f7f7f7",
    opacity: 0.29
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    width: 2.4,
    height: 6.6,
    x: 231.3,
    y: 461.8,
    fill: "#f7f7f7"
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    width: 2.4,
    height: 6.6,
    x: 236,
    y: 461.8,
    fill: "#f7f7f7"
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    width: 2.4,
    height: 6.6,
    x: 240.7,
    y: 461.8,
    fill: "#f7f7f7"
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    width: 50.7,
    height: 105.8,
    x: 122.8,
    y: 359.3,
    fill: "#f7f7f7"
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    width: 53.6,
    height: 3,
    x: 121.3,
    y: 357.5,
    fill: "#f7f7f7"
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    width: 47.3,
    height: 14.2,
    x: 124.5,
    y: 353.7,
    fill: "#f7f7f7"
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    width: 18.7,
    height: 15.5,
    x: 128.1,
    y: 347.9,
    fill: "#f7f7f7"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#f7f7f7",
    points: "138.9 352.2 128.1 352.2 128.1 344.1 135.8 344.1"
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    width: 1.1,
    height: 18.2,
    x: 132.4,
    y: 337.3,
    fill: "#f7f7f7"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 133,
    cy: 336.3,
    r: 0.9,
    fill: "#f7f7f7"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#f7f7f7",
    points: "593.3 473.1 537.8 473.1 530.9 317.6 593.3 330.6"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#f7f7f7",
    points: "351.2 384.3 351.2 332.3 342.5 332.3 342.5 318.4 339.4 318.4 339.4 298 322.2 298 322.2 283 320.7 283 320.7 298 317.4 298 317.4 279.2 315.8 279.2 315.8 298 305 298 305 332.3 299.4 332.3 299.4 384.3 294.6 384.3 294.6 479 354.6 479 354.6 384.3"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#8caaa7",
    points: "442.2 483.1 412.9 483.1 424.3 424.3 442.2 424.3"
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    width: 696.3,
    height: 45.6,
    x: 28.1,
    y: 485.4,
    fill: "#cce9ff"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#cce9ff",
    points: "418.2 374.3 418.2 348.2 408.7 348.2 408.7 338.3 403.7 338.3 403.7 330 401.9 330 401.9 315.7 401.5 315.7 401.5 330 399.7 330 399.7 338.3 394.7 338.3 394.7 348.2 385.3 348.2 385.3 374.3 383.4 374.3 383.4 421.6 368.8 421.6 368.8 475.5 383.4 475.5 397.9 475.5 420 475.5 420 374.3"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#cce9ff",
    points: "472.4 404.2 426.7 404.2 426.7 405.1 428.8 405.1 428.8 482.2 470.3 482.2 470.3 405.1 472.4 405.1"
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    width: 40.5,
    height: 64.3,
    x: 223.8,
    y: 423.5,
    fill: "#cce9ff"
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    width: 69.6,
    height: 31.3,
    x: 148.1,
    y: 456.4,
    fill: "#cce9ff"
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    width: 15.3,
    height: 77,
    x: 185.4,
    y: 386.4,
    fill: "#cce9ff"
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    width: 0.8,
    height: 41.9,
    x: 188.8,
    y: 365.8,
    fill: "#cce9ff"
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    width: 0.8,
    height: 41.9,
    x: 191.4,
    y: 369,
    fill: "#cce9ff"
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    width: 9.3,
    height: 10.3,
    x: 186.6,
    y: 381.6,
    fill: "#cce9ff"
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    width: 26.6,
    height: 52.8,
    x: 215,
    y: 435,
    fill: "#cce9ff"
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    width: 49.9,
    height: 108.6,
    x: 270.8,
    y: 379.1,
    fill: "#cce9ff"
  })), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    width: 40.1,
    height: 18.1,
    x: 275.7,
    y: 375.4,
    fill: "#cce9ff"
  })), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    width: 57.6,
    height: 1.3,
    x: 266.9,
    y: 381.4,
    fill: "#cce9ff"
  })), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    width: 23.5,
    height: 54.9,
    x: 261.8,
    y: 432.9,
    fill: "#cce9ff"
  })), _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 56.9,
    x: 93.3,
    y: 430.8,
    fill: "#cce9ff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 53.8,
    height: 72.4,
    x: 102.1,
    y: 415.3,
    fill: "#cce9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 58.3,
    height: 2.8,
    x: 98.9,
    y: 412.5,
    fill: "#cce9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 23.6,
    height: 14.7,
    x: 104.5,
    y: 405,
    fill: "#cce9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 8.9,
    x: 135.8,
    y: 405,
    fill: "#cce9ff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.4,
    height: 8.9,
    x: 143.7,
    y: 405,
    fill: "#cce9ff"
  }))), _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    width: 28.2,
    height: 22,
    x: 78.7,
    y: 465.7,
    fill: "#cce9ff"
  })), _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    width: 13.3,
    height: 31.3,
    x: 68,
    y: 456.4,
    fill: "#cce9ff"
  })), _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    width: 22.8,
    height: 11,
    x: 51.9,
    y: 476.7,
    fill: "#cce9ff"
  })), _rect101 || (_rect101 = /*#__PURE__*/React.createElement("rect", {
    width: 281,
    height: 24.4,
    x: 315.8,
    y: 463.3,
    fill: "#cce9ff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#cce9ff",
    d: "M574.3,395.8c-1.8,0-3.2,1.4-3.4,3.1l-4-0.1c0-0.4,0-0.8,0-1.2c0-4.9-0.8-9.7-2.5-14.2l3.3-1.2 c0.5,1.2,1.7,2,3.1,2c1.9,0,3.4-1.5,3.4-3.4c0-1.9-1.5-3.4-3.4-3.4c-1.9,0-3.4,1.5-3.4,3.4c0,0.3,0.1,0.7,0.1,1l-3.3,1.2 c-1.9-5-4.8-9.7-8.5-13.8l2.6-2.4c0.6,0.6,1.4,0.9,2.3,0.9c1.9,0,3.4-1.5,3.4-3.4c0-1.9-1.5-3.4-3.4-3.4s-3.4,1.5-3.4,3.4 c0,0.8,0.3,1.6,0.8,2.2l-2.6,2.4c-0.3-0.3-0.5-0.6-0.8-0.8c-3.9-3.9-8.5-7-13.4-9l1.4-3.5c0.3,0.1,0.7,0.2,1,0.2 c1.9,0,3.4-1.5,3.4-3.4c0-1.9-1.5-3.4-3.4-3.4c-1.9,0-3.4,1.5-3.4,3.4c0,1.4,0.8,2.6,2,3.1l-1.4,3.5c-4.4-1.8-9.2-2.8-14.1-3 l0.2-4.7c0,0,0.1,0,0.1,0c1.9,0,3.4-1.5,3.4-3.4c0-1.9-1.5-3.4-3.4-3.4c-1.9,0-3.4,1.5-3.4,3.4c0,1.7,1.3,3.1,2.9,3.3l-0.2,4.8 c-0.4,0-0.8,0-1.2,0c-4.7,0-9.3,0.8-13.7,2.3l-1.4-3.9c1.2-0.5,2.1-1.7,2.1-3.1c0-1.9-1.5-3.4-3.4-3.4c-1.9,0-3.4,1.5-3.4,3.4 c0,1.9,1.5,3.4,3.4,3.4c0.3,0,0.6,0,0.9-0.1l1.4,3.9c-5.3,1.9-10.1,4.8-14.3,8.7l-2.5-2.6c0.6-0.6,0.9-1.4,0.9-2.3 c0-1.9-1.5-3.4-3.4-3.4c-1.9,0-3.4,1.5-3.4,3.4c0,1.9,1.5,3.4,3.4,3.4c0.8,0,1.6-0.3,2.2-0.8l2.5,2.6c-0.3,0.3-0.6,0.5-0.8,0.8 c-3.5,3.5-6.3,7.5-8.3,11.8l-3.1-1.4c0.1-0.3,0.2-0.7,0.2-1.1c0-1.9-1.5-3.4-3.4-3.4c-1.9,0-3.4,1.5-3.4,3.4c0,1.9,1.5,3.4,3.4,3.4 c1.4,0,2.5-0.8,3.1-2l3.1,1.4c-2.2,4.9-3.5,10.2-3.7,15.7l-4-0.1c0-1.8-1.5-3.3-3.4-3.3c-1.9,0-3.4,1.5-3.4,3.4 c0,1.9,1.5,3.4,3.4,3.4c1.8,0,3.2-1.4,3.4-3.1l4,0.1c0,0.4,0,0.8,0,1.2c0,4.9,0.8,9.7,2.5,14.2L483,413c-0.5-1.2-1.7-2-3.1-2 c-1.9,0-3.4,1.5-3.4,3.4s1.5,3.4,3.4,3.4c1.9,0,3.4-1.5,3.4-3.4c0-0.3-0.1-0.7-0.1-1l3.3-1.2c1.9,5,4.8,9.7,8.5,13.8l-2.6,2.4 c-0.6-0.6-1.4-0.9-2.3-0.9c-1.9,0-3.4,1.5-3.4,3.4c0,1.9,1.5,3.4,3.4,3.4c1.9,0,3.4-1.5,3.4-3.4c0-0.8-0.3-1.6-0.8-2.2l2.6-2.4 c0.3,0.3,0.5,0.6,0.8,0.8c2.6,2.6,5.6,4.9,8.7,6.7l-20.4,37.5h-3.7v1.1h-1.8v2.1h93v-2.1h-1.8v-1.1h-3.7l-20.4-37.5 c2.7-1.6,5.3-3.4,7.6-5.6l3.3,3.5c-0.7,0.6-1.2,1.5-1.2,2.5c0,1.9,1.5,3.4,3.4,3.4c1.9,0,3.4-1.5,3.4-3.4c0-1.9-1.5-3.4-3.4-3.4 c-0.7,0-1.4,0.2-1.9,0.6l-3.3-3.5c0.3-0.3,0.6-0.5,0.8-0.8c3.5-3.5,6.3-7.5,8.3-11.8l3.7,1.7c-0.1,0.3-0.1,0.5-0.1,0.8 c0,1.9,1.5,3.4,3.4,3.4c1.9,0,3.4-1.5,3.4-3.4c0-1.9-1.5-3.4-3.4-3.4c-1.4,0-2.7,0.9-3.2,2.2l-3.6-1.7c2.2-4.9,3.5-10.2,3.7-15.7 l4,0.1c0,1.8,1.5,3.3,3.4,3.3c1.9,0,3.4-1.5,3.4-3.4C577.7,397.3,576.2,395.8,574.3,395.8z M565.9,397.6c0,0.4,0,0.8,0,1.1 l-11.6-0.4c0-0.2,0-0.5,0-0.7c0-3.4-0.6-6.7-1.7-9.8l11-4C565.1,388.1,565.9,392.8,565.9,397.6z M553.7,398.3l-26-0.8 c0-0.2,0-0.3-0.1-0.5l24.4-9c1.1,3,1.7,6.2,1.7,9.6C553.7,397.8,553.7,398.1,553.7,398.3z M497.2,396.9l26,0.8c0,0.2,0,0.3,0.1,0.5 l-24.4,9c-1.1-3-1.7-6.2-1.7-9.6C497.2,397.3,497.2,397.1,497.2,396.9z M527.2,396.2l19-17.8c2.5,2.7,4.4,5.8,5.7,9.2l-24.4,9 C527.4,396.5,527.3,396.3,527.2,396.2z M527,395.9c-0.1-0.1-0.3-0.2-0.5-0.3l9.9-24c3.6,1.5,6.9,3.8,9.6,6.6L527,395.9z  M526.1,395.4c-0.1,0-0.3-0.1-0.4-0.1l0.8-26c3.3,0.1,6.5,0.8,9.5,2L526.1,395.4z M525.3,395.3c-0.2,0-0.3,0-0.5,0.1l-8.6-24.5 c2.9-1,6-1.5,9.2-1.5c0.2,0,0.5,0,0.7,0L525.3,395.3z M524.5,395.5c-0.2,0.1-0.3,0.2-0.5,0.3l-17.8-19c2.8-2.5,6-4.6,9.6-5.9 L524.5,395.5z M523.7,396.1c-0.1,0.1-0.2,0.3-0.3,0.4l-23.6-10.9c1.5-3.2,3.6-6.1,6.1-8.5L523.7,396.1z M523.3,396.8 c-0.1,0.2-0.1,0.3-0.1,0.5l-26-0.8c0.1-3.8,1-7.3,2.5-10.6L523.3,396.8z M523.4,398.5c0.1,0.1,0.1,0.3,0.2,0.4l-0.2,0.3l-18.7,17.6 c-2.5-2.7-4.4-5.8-5.7-9.2L523.4,398.5z M522.9,400.2l-11.8,21.7c-2.3-1.3-4.3-3-6.2-4.9L522.9,400.2z M524.2,399.5 c0.1,0.1,0.2,0.1,0.2,0.1l-9.9,24c-1-0.4-1.9-0.9-2.8-1.3L524.2,399.5z M524.7,399.7c0.1,0,0.3,0.1,0.4,0.1l-0.8,26 c-3.3-0.1-6.5-0.8-9.5-2L524.7,399.7z M525.4,425.8c-0.2,0-0.5,0-0.7,0l0.8-26c0.2,0,0.3,0,0.5-0.1l8.6,24.5 C531.8,425.3,528.7,425.8,525.4,425.8z M526.4,399.7c0.1-0.1,0.2-0.1,0.4-0.2l12.4,22.8c-1.3,0.7-2.7,1.4-4.1,1.9L526.4,399.7z  M528.4,401.1l16.2,17.2c-1.5,1.4-3.1,2.6-4.8,3.6L528.4,401.1z M527.7,399.8l-0.5-0.9c0-0.1,0.1-0.1,0.1-0.2l23.6,10.9 c-1.5,3.2-3.6,6.1-6.1,8.5L527.7,399.8z M527.6,398.4c0.1-0.2,0.1-0.3,0.1-0.5l26,0.8c-0.1,3.8-1,7.3-2.5,10.6L527.6,398.4z  M514.3,424.2l-4.4,10.8c-1.4-0.6-2.7-1.2-4-1.9l5.6-10.3C512.4,423.3,513.3,423.8,514.3,424.2z M514.7,424.3 c3,1.2,6.3,1.9,9.7,2.1l-0.4,11.7c-4.8-0.2-9.4-1.2-13.7-2.9L514.7,424.3z M524.7,426.4c0.2,0,0.5,0,0.7,0c3.3,0,6.5-0.6,9.4-1.6 l3.9,11c-4.2,1.5-8.7,2.2-13.3,2.2c-0.4,0-0.8,0-1.1,0L524.7,426.4z M535.2,424.7c1.5-0.5,2.9-1.2,4.2-1.9l5.6,10.3 c-1.9,1-3.9,1.9-5.9,2.7L535.2,424.7z M563.4,383.4l-11,4c-1.3-3.5-3.3-6.7-5.8-9.4l8.5-8C558.8,374,561.5,378.5,563.4,383.4z  M554.1,369c0.3,0.3,0.5,0.5,0.8,0.8l-8.5,8c-2.7-2.9-6.1-5.2-9.8-6.8l4.4-10.8C545.8,362.2,550.2,365.2,554.1,369z M540.6,360 l-4.4,10.8c-3-1.2-6.3-1.9-9.7-2.1l0.4-11.7C531.7,357.3,536.3,358.3,540.6,360z M525.4,357.1c0.4,0,0.8,0,1.1,0l-0.4,11.6 c-0.2,0-0.5,0-0.7,0c-3.3,0-6.5,0.6-9.4,1.6l-3.9-11C516.4,357.9,520.8,357.1,525.4,357.1z M511.8,359.4l3.9,11 c-3.7,1.3-7,3.4-9.8,6l-8-8.5C502,364.1,506.7,361.3,511.8,359.4z M496.8,369c0.3-0.3,0.5-0.5,0.8-0.8l8,8.5 c-2.6,2.5-4.7,5.4-6.3,8.6l-10.6-4.9C490.7,376.2,493.4,372.3,496.8,369z M488.6,380.8l10.6,4.9c-1.5,3.3-2.4,7-2.6,10.8l-11.7-0.4 C485.2,390.7,486.4,385.5,488.6,380.8z M485,397.6c0-0.4,0-0.8,0-1.1l11.6,0.4c0,0.2,0,0.5,0,0.7c0,3.4,0.6,6.7,1.7,9.8l-11,4 C485.8,407,485,402.4,485,397.6z M487.5,411.8l11-4c1.3,3.5,3.3,6.7,5.8,9.4l-8.5,8C492.1,421.2,489.3,416.7,487.5,411.8z  M496.8,426.2c-0.3-0.3-0.5-0.5-0.8-0.8l8.5-8c1.8,1.9,4,3.6,6.3,5l-5.6,10.3C502.2,430.9,499.4,428.8,496.8,426.2z M565.6,471.2 h-80.4l20.2-37.2c1.3,0.7,2.7,1.4,4.1,2l-1.4,3.5c-0.3-0.1-0.7-0.2-1-0.2c-1.9,0-3.4,1.5-3.4,3.4c0,1.9,1.5,3.4,3.4,3.4 c1.9,0,3.4-1.5,3.4-3.4c0-1.4-0.8-2.6-2-3.1l1.4-3.5c4.4,1.8,9.2,2.8,14.1,3l-0.1,3.5c-1.8,0-3.3,1.5-3.3,3.4 c0,1.9,1.5,3.4,3.4,3.4c1.9,0,3.4-1.5,3.4-3.4c0-1.8-1.4-3.2-3.1-3.4l0.1-3.5c0.4,0,0.8,0,1.2,0c4.7,0,9.3-0.8,13.7-2.3l1.2,3.4 c-1.1,0.5-1.9,1.7-1.9,3.1c0,1.9,1.5,3.4,3.4,3.4s3.4-1.5,3.4-3.4c0-1.9-1.5-3.4-3.4-3.4c-0.4,0-0.7,0.1-1.1,0.2l-1.2-3.4 c2.1-0.7,4.1-1.7,6-2.7L565.6,471.2z M545.6,432.7l-5.6-10.3c1.8-1.1,3.4-2.3,5-3.7l8,8.5C550.7,429.4,548.2,431.2,545.6,432.7z  M554.1,426.2c-0.3,0.3-0.5,0.5-0.8,0.8l-8-8.5c2.6-2.5,4.7-5.4,6.3-8.6l10.6,4.9C560.2,418.9,557.4,422.8,554.1,426.2z  M562.3,414.4l-10.6-4.9c1.5-3.3,2.4-7,2.6-10.8l11.7,0.4C565.7,404.4,564.5,409.6,562.3,414.4z"
  })), _rect102 || (_rect102 = /*#__PURE__*/React.createElement("rect", {
    width: 43.4,
    height: 63.6,
    x: 582.5,
    y: 424.2,
    fill: "#cce9ff"
  })), _rect103 || (_rect103 = /*#__PURE__*/React.createElement("rect", {
    width: 43.4,
    height: 38.5,
    x: 619.5,
    y: 448.9,
    fill: "#cce9ff"
  })), _rect104 || (_rect104 = /*#__PURE__*/React.createElement("rect", {
    width: 24.3,
    height: 32.3,
    x: 451.3,
    y: 443.2,
    fill: "#cce9ff"
  })), _rect105 || (_rect105 = /*#__PURE__*/React.createElement("rect", {
    width: 30.7,
    height: 124,
    x: 604.2,
    y: 363.7,
    fill: "#cce9ff"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#cce9ff",
    points: "685.4 487.7 644.9 487.7 644.9 415.3 675.6 415.3"
  })), _rect106 || (_rect106 = /*#__PURE__*/React.createElement("rect", {
    width: 35.4,
    height: 16.5,
    x: 667.7,
    y: 471.2,
    fill: "#cce9ff"
  })), _rect107 || (_rect107 = /*#__PURE__*/React.createElement("rect", {
    width: 1.1,
    height: 33.7,
    x: 626.9,
    y: 337.8,
    fill: "#cce9ff"
  })), _rect108 || (_rect108 = /*#__PURE__*/React.createElement("rect", {
    width: 1.1,
    height: 33.7,
    x: 630.5,
    y: 345,
    fill: "#cce9ff"
  })), _rect109 || (_rect109 = /*#__PURE__*/React.createElement("rect", {
    width: 1.1,
    height: 33.7,
    x: 623.7,
    y: 349.7,
    fill: "#cce9ff"
  })), _rect110 || (_rect110 = /*#__PURE__*/React.createElement("rect", {
    width: 14.5,
    height: 11.4,
    x: 646.5,
    y: 409.5,
    fill: "#cce9ff"
  })), _rect111 || (_rect111 = /*#__PURE__*/React.createElement("rect", {
    width: 11.3,
    height: 6.4,
    x: 648.1,
    y: 405.4,
    fill: "#cce9ff"
  })), _rect112 || (_rect112 = /*#__PURE__*/React.createElement("rect", {
    width: 2.8,
    height: 4.6,
    x: 666.7,
    y: 412.8,
    fill: "#cce9ff"
  })), _rect113 || (_rect113 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 8.8,
    x: 670.5,
    y: 408.6,
    fill: "#cce9ff"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#2a94f4",
    d: "M623.9,381.5c0-0.5-0.4-0.9-0.8-0.9c-0.4,0-0.8,0.4-0.8,0.9s0.4,0.9,0.8,0.9 C623.6,382.5,623.9,382.1,623.9,381.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#2a94f4",
    points: "710.2 496.2 705.3 463.3 695.3 463.3 695.3 436.1 696.5 436.1 696.5 433.6 691.6 433.6 691.6 423 691 423 691 433.6 687.7 433.6 687.7 424.9 687.1 424.9 687.1 433.6 666.7 433.6 666.7 436.1 668.1 436.1 668.1 491.4 644.9 491.4 644.9 466.6 631.7 466.6 631.7 405.7 632.9 405.7 632.9 402.7 630.3 402.7 630.3 398.9 627.2 398.9 627.2 397.4 627.2 393.1 627.2 389.3 623.6 389.3 623.6 382.5 623.1 382.5 622.7 382.5 622.7 389.3 620.7 389.3 619.5 393.1 611.5 393.1 611.5 398.9 590.6 398.9 590.6 402.7 587.9 402.7 587.9 405.7 589.1 405.7 589.1 445.3 571.6 445.3 571.6 484.3 552.2 475.7 552.2 437.9 555.3 437.9 555.3 435.1 549.8 435.1 549.8 427.5 526.2 427.5 526.2 435.1 518.4 435.1 518.4 427.5 514.5 427.5 514.5 435.1 510.5 435.1 510.5 427.5 506.1 427.5 506.1 435.1 497 435.1 497 437.9 498.4 437.9 498.4 490.3 489.5 490.3 489.5 489.7 487.9 489.7 487.9 474.8 489.5 474.8 489.5 473.6 487.9 473.6 487.9 458.6 489.5 458.6 489.5 457.4 487.9 457.4 487.9 442.5 489.5 442.5 489.5 441.3 487.9 441.3 487.9 426.4 489.5 426.4 489.5 425.2 487.9 425.2 487.9 410.3 489.5 410.3 489.5 409.1 487.9 409.1 487.9 393.6 490.7 393.6 490.7 392.4 492.1 392.4 492.1 389.1 466 389.1 466 385.5 466.8 385.5 466.8 384.4 452.6 384.4 452.6 385.5 453.5 385.5 453.5 389.1 447 389.1 447 392.4 448.4 392.4 448.4 393.6 451.1 393.6 451.1 409.1 449.5 409.1 449.5 410.3 451.1 410.3 451.1 425.2 449.5 425.2 449.5 426.4 451.1 426.4 451.1 441.3 449.5 441.3 449.5 442.5 451.1 442.5 451.1 457.4 449.5 457.4 449.5 458.6 451.1 458.6 451.1 473.6 449.5 473.6 449.5 474.8 451.1 474.8 451.1 489.7 449.5 489.7 449.5 490.9 451.1 490.9 451.1 503.1 442.2 503.1 442.2 456 406.4 456 406.4 490.3 400.6 490.3 400.6 383.4 396.3 383.4 396.3 386.1 388.3 388.1 388.3 386.3 384 386.3 384 389.1 376.1 391.1 376.1 389 371.8 389 371.8 392.1 363.8 394.1 363.8 392.4 359.5 392.4 359.5 395.1 351.6 397.1 351.6 395.6 347.3 395.6 347.3 500.6 341.2 500.6 341.2 444.6 318.8 444.6 318.8 479 295.8 479 295.8 449.7 292.9 449.7 292.9 440.1 294.6 440.1 294.6 439.1 287.2 439.1 287.2 436.1 286.4 436.1 286.4 439.1 284 439.1 284 423.5 283.4 423.5 283.4 439.1 280.3 439.1 280.3 440.1 282.1 440.1 282.1 449.7 266.9 449.7 266.9 472.1 252.2 472.1 244.4 500.6 229 500.6 229 407.5 208.5 407.5 208.5 404.2 209.6 404.2 209.6 403 194.1 403 194.1 404.2 195.3 404.2 195.3 407.5 195.3 412.9 195.3 476.6 185.6 476.6 185.6 452.5 189.1 452.5 189.1 450.3 164.7 450.3 164.7 435.8 160.1 435.8 160.1 432.8 149.7 432.8 149.7 435.8 141.3 435.8 141.3 487.7 113.7 487.7 113.7 449.2 90.4 449.2 90.4 479.6 70.2 479.6 70.2 499.1 55.6 499.1 55.6 474.6 36.4 474.6 36.4 495.5 19.1 495.5 19.1 531 36.4 531 42.3 531 51.9 531 55.6 531 70.2 531 90.4 531 97.2 531 100.8 531 113.7 531 141.3 531 149.7 531 160.1 531 164.7 531 182.9 531 185.6 531 195.3 531 211.5 531 219.5 531 229 531 266.9 531 275.7 531 290.5 531 295.8 531 319.2 531 325.4 531 347.3 531 349.4 531 351.6 531 359.5 531 363.8 531 371.8 531 375.4 531 376.1 531 384 531 388.3 531 395.2 531 396.3 531 398.4 531 400.6 531 406.4 531 436 531 440.3 531 442.2 531 451.1 531 466.8 531 481.2 531 487.9 531 498.4 531 524.4 531 551.9 531 552.2 531 571.6 531 582.5 531 589.1 531 593.3 531 625.9 531 631.7 531 638.7 531 644.9 531 668.1 531 685.4 531 688.9 531 695.3 531 733.9 531 733.9 496.2"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.52
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1.8,
    height: 1.8,
    x: 143.7,
    y: 439.6,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.8,
    height: 1.8,
    x: 147.3,
    y: 439.6,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.8,
    height: 1.8,
    x: 143.7,
    y: 443.7,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.8,
    height: 1.8,
    x: 147.3,
    y: 443.7,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.8,
    height: 1.8,
    x: 143.7,
    y: 447.8,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.8,
    height: 1.8,
    x: 151.3,
    y: 439.6,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 1.2,
    height: 6.7,
    x: 273.5,
    y: 386.3,
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.2,
    height: 6.7,
    x: 277.7,
    y: 386.3,
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.2,
    height: 6.7,
    x: 281.9,
    y: 386.3,
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.2,
    height: 6.7,
    x: 286,
    y: 386.3,
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.2,
    height: 6.7,
    x: 290.2,
    y: 386.3,
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.2,
    height: 6.7,
    x: 294.4,
    y: 386.3,
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.2,
    height: 6.7,
    x: 298.5,
    y: 386.3,
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.2,
    height: 6.7,
    x: 302.7,
    y: 386.3,
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.2,
    height: 6.7,
    x: 306.9,
    y: 386.3,
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.2,
    height: 6.7,
    x: 311,
    y: 386.3,
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.2,
    height: 6.7,
    x: 315.2,
    y: 386.3,
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.2,
    height: 6.7,
    x: 273.5,
    y: 395.6,
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.2,
    height: 6.7,
    x: 277.7,
    y: 395.6,
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.2,
    height: 6.7,
    x: 281.9,
    y: 395.6,
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.2,
    height: 6.7,
    x: 286,
    y: 395.6,
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.2,
    height: 6.7,
    x: 290.2,
    y: 395.6,
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.2,
    height: 6.7,
    x: 294.4,
    y: 395.6,
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.2,
    height: 6.7,
    x: 298.5,
    y: 395.6,
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.2,
    height: 6.7,
    x: 302.7,
    y: 395.6,
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.2,
    height: 6.7,
    x: 306.9,
    y: 395.6,
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.2,
    height: 6.7,
    x: 311,
    y: 395.6,
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.2,
    height: 6.7,
    x: 315.2,
    y: 395.6,
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.2,
    height: 6.7,
    x: 273.5,
    y: 404.9,
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.2,
    height: 6.7,
    x: 277.7,
    y: 404.9,
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.2,
    height: 6.7,
    x: 281.9,
    y: 404.9,
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.2,
    height: 6.7,
    x: 286,
    y: 404.9,
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.2,
    height: 6.7,
    x: 290.2,
    y: 404.9,
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.2,
    height: 6.7,
    x: 294.4,
    y: 404.9,
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.2,
    height: 6.7,
    x: 298.5,
    y: 404.9,
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.2,
    height: 6.7,
    x: 302.7,
    y: 404.9,
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.2,
    height: 6.7,
    x: 306.9,
    y: 404.9,
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.2,
    height: 6.7,
    x: 311,
    y: 404.9,
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.2,
    height: 6.7,
    x: 315.2,
    y: 404.9,
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.2,
    height: 6.7,
    x: 286,
    y: 414.3,
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.2,
    height: 6.7,
    x: 290.2,
    y: 414.3,
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.2,
    height: 6.7,
    x: 294.4,
    y: 414.3,
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.2,
    height: 6.7,
    x: 298.5,
    y: 414.3,
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.2,
    height: 6.7,
    x: 302.7,
    y: 414.3,
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.2,
    height: 6.7,
    x: 306.9,
    y: 414.3,
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.2,
    height: 6.7,
    x: 311,
    y: 414.3,
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.2,
    height: 6.7,
    x: 315.2,
    y: 414.3,
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.2,
    height: 6.7,
    x: 290.2,
    y: 424.1,
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.2,
    height: 6.7,
    x: 294.4,
    y: 424.1,
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.2,
    height: 6.7,
    x: 298.5,
    y: 424.1,
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.2,
    height: 6.7,
    x: 302.7,
    y: 424.1,
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.2,
    height: 6.7,
    x: 306.9,
    y: 424.1,
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.2,
    height: 6.7,
    x: 311,
    y: 424.1,
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.2,
    height: 6.7,
    x: 315.2,
    y: 424.1,
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.9,
    height: 7.2,
    x: 354.1,
    y: 402.9,
    fill: "#fff",
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.9,
    height: 7.2,
    x: 354.1,
    y: 416.8,
    fill: "#fff",
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.9,
    height: 7.2,
    x: 354.1,
    y: 430.6,
    fill: "#fff",
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.9,
    height: 7.2,
    x: 354.1,
    y: 444.5,
    fill: "#fff",
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.9,
    height: 7.2,
    x: 354.1,
    y: 457.6,
    fill: "#fff",
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.9,
    height: 7.2,
    x: 354.1,
    y: 471.4,
    fill: "#fff",
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.9,
    height: 7.2,
    x: 366.4,
    y: 402.9,
    fill: "#fff",
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.9,
    height: 7.2,
    x: 366.4,
    y: 416.8,
    fill: "#fff",
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.9,
    height: 7.2,
    x: 366.4,
    y: 430.6,
    fill: "#fff",
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.9,
    height: 7.2,
    x: 366.4,
    y: 444.5,
    fill: "#fff",
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.9,
    height: 7.2,
    x: 366.4,
    y: 457.6,
    fill: "#fff",
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.9,
    height: 7.2,
    x: 366.4,
    y: 471.4,
    fill: "#fff",
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.9,
    height: 7.2,
    x: 378.6,
    y: 402.9,
    fill: "#fff",
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.9,
    height: 7.2,
    x: 378.6,
    y: 416.8,
    fill: "#fff",
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.9,
    height: 7.2,
    x: 378.6,
    y: 430.6,
    fill: "#fff",
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.9,
    height: 7.2,
    x: 378.6,
    y: 444.5,
    fill: "#fff",
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.9,
    height: 7.2,
    x: 378.6,
    y: 457.6,
    fill: "#fff",
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.9,
    height: 7.2,
    x: 378.6,
    y: 471.4,
    fill: "#fff",
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.9,
    height: 7.2,
    x: 390.9,
    y: 402.9,
    fill: "#fff",
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.9,
    height: 7.2,
    x: 390.9,
    y: 416.8,
    fill: "#fff",
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.9,
    height: 7.2,
    x: 390.9,
    y: 430.6,
    fill: "#fff",
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.9,
    height: 7.2,
    x: 390.9,
    y: 444.5,
    fill: "#fff",
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.9,
    height: 7.2,
    x: 390.9,
    y: 457.6,
    fill: "#fff",
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.9,
    height: 7.2,
    x: 390.9,
    y: 471.4,
    fill: "#fff",
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.4,
    height: 6.3,
    x: 308.1,
    y: 301.9,
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.4,
    height: 6.3,
    x: 313.9,
    y: 301.9,
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.4,
    height: 6.3,
    x: 319.8,
    y: 301.9,
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.4,
    height: 6.3,
    x: 325.7,
    y: 301.9,
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.4,
    height: 6.3,
    x: 308.1,
    y: 312.4,
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.4,
    height: 6.3,
    x: 313.9,
    y: 312.4,
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.4,
    height: 6.3,
    x: 319.8,
    y: 312.4,
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.4,
    height: 6.3,
    x: 325.7,
    y: 312.4,
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.4,
    height: 6.3,
    x: 308.1,
    y: 323,
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.4,
    height: 6.3,
    x: 313.9,
    y: 323,
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.4,
    height: 6.3,
    x: 332.3,
    y: 301.9,
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.5,
    height: 5.8,
    x: 149.7,
    y: 366.1,
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.5,
    height: 5.8,
    x: 155.1,
    y: 366.1,
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.5,
    height: 5.8,
    x: 161.3,
    y: 366.1,
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.5,
    height: 5.8,
    x: 166.7,
    y: 366.1,
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.5,
    height: 5.8,
    x: 137.9,
    y: 366.1,
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.5,
    height: 5.8,
    x: 143.2,
    y: 366.1,
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.5,
    height: 5.8,
    x: 149.7,
    y: 376.2,
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.5,
    height: 5.8,
    x: 155.1,
    y: 376.2,
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.5,
    height: 5.8,
    x: 161.3,
    y: 376.2,
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.5,
    height: 5.8,
    x: 166.7,
    y: 376.2,
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.5,
    height: 5.8,
    x: 137.9,
    y: 376.2,
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.5,
    height: 5.8,
    x: 143.2,
    y: 376.2,
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.5,
    height: 5.8,
    x: 149.7,
    y: 386.3,
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.5,
    height: 5.8,
    x: 155.1,
    y: 386.3,
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.5,
    height: 5.8,
    x: 161.3,
    y: 386.3,
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.5,
    height: 5.8,
    x: 166.7,
    y: 386.3,
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.5,
    height: 5.8,
    x: 137.9,
    y: 386.3,
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.5,
    height: 5.8,
    x: 143.2,
    y: 386.3,
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.3,
    height: 9,
    x: 431.9,
    y: 410.7,
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.3,
    height: 9,
    x: 439.1,
    y: 410.7,
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.3,
    height: 9,
    x: 445.8,
    y: 410.7,
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.8,
    height: 5.1,
    x: 593.3,
    y: 412.5,
    fill: "#fff",
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.8,
    height: 5.1,
    x: 598.9,
    y: 412.5,
    fill: "#fff",
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.8,
    height: 5.1,
    x: 593.3,
    y: 412.5,
    fill: "#fff",
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.8,
    height: 5.1,
    x: 598.9,
    y: 412.5,
    fill: "#fff",
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.8,
    height: 5.1,
    x: 604.2,
    y: 412.5,
    fill: "#fff",
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.8,
    height: 5.1,
    x: 609.8,
    y: 412.5,
    fill: "#fff",
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.8,
    height: 5.1,
    x: 593.3,
    y: 421.6,
    fill: "#fff",
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.8,
    height: 5.1,
    x: 598.9,
    y: 421.6,
    fill: "#fff",
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.8,
    height: 5.1,
    x: 593.3,
    y: 421.6,
    fill: "#fff",
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.8,
    height: 5.1,
    x: 598.9,
    y: 421.6,
    fill: "#fff",
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.8,
    height: 5.1,
    x: 604.2,
    y: 421.6,
    fill: "#fff",
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.8,
    height: 5.1,
    x: 609.8,
    y: 421.6,
    fill: "#fff",
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.8,
    height: 5.1,
    x: 593.3,
    y: 431.3,
    fill: "#fff",
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.8,
    height: 5.1,
    x: 598.9,
    y: 431.3,
    fill: "#fff",
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.8,
    height: 5.1,
    x: 593.3,
    y: 431.3,
    fill: "#fff",
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.8,
    height: 5.1,
    x: 598.9,
    y: 431.3,
    fill: "#fff",
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.8,
    height: 5.1,
    x: 604.2,
    y: 431.3,
    fill: "#fff",
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.8,
    height: 5.1,
    x: 609.8,
    y: 431.3,
    fill: "#fff",
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.8,
    height: 5.1,
    x: 615.8,
    y: 412.5,
    fill: "#fff",
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.8,
    height: 5.1,
    x: 615.8,
    y: 421.6,
    fill: "#fff",
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.8,
    height: 5.1,
    x: 621.4,
    y: 412.5,
    fill: "#fff",
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.9,
    height: 7.9,
    x: 454.5,
    y: 397.5,
    fill: "#fff",
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.9,
    height: 7.9,
    x: 464,
    y: 397.5,
    fill: "#fff",
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.9,
    height: 7.9,
    x: 473.5,
    y: 397.5,
    fill: "#fff",
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.9,
    height: 7.9,
    x: 483,
    y: 397.5,
    fill: "#fff",
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.9,
    height: 7.9,
    x: 454.5,
    y: 413.8,
    fill: "#fff",
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.9,
    height: 7.9,
    x: 464,
    y: 413.8,
    fill: "#fff",
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.9,
    height: 7.9,
    x: 473.5,
    y: 413.8,
    fill: "#fff",
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.9,
    height: 7.9,
    x: 483,
    y: 413.8,
    fill: "#fff",
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.9,
    height: 7.9,
    x: 454.5,
    y: 430.4,
    fill: "#fff",
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.9,
    height: 7.9,
    x: 464,
    y: 430.4,
    fill: "#fff",
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.9,
    height: 7.9,
    x: 473.5,
    y: 430.4,
    fill: "#fff",
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.9,
    height: 7.9,
    x: 483,
    y: 430.4,
    fill: "#fff",
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.9,
    height: 7.9,
    x: 454.5,
    y: 447.1,
    fill: "#fff",
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.9,
    height: 7.9,
    x: 464,
    y: 447.1,
    fill: "#fff",
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.9,
    height: 7.9,
    x: 473.5,
    y: 447.1,
    fill: "#fff",
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.9,
    height: 7.9,
    x: 483,
    y: 447.1,
    fill: "#fff",
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.9,
    height: 7.9,
    x: 454.5,
    y: 462.3,
    fill: "#fff",
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.9,
    height: 7.9,
    x: 464,
    y: 462.3,
    fill: "#fff",
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.9,
    height: 7.9,
    x: 473.5,
    y: 462.3,
    fill: "#fff",
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.9,
    height: 7.9,
    x: 454.5,
    y: 479.2,
    fill: "#fff",
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.9,
    height: 7.9,
    x: 464,
    y: 479.2,
    fill: "#fff",
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.9,
    height: 7.9,
    x: 473.5,
    y: 479.2,
    fill: "#fff",
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.9,
    height: 7.9,
    x: 483,
    y: 462.3,
    fill: "#fff",
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 4.5,
    x: 670.5,
    y: 439.3,
    fill: "#fff",
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 4.5,
    x: 670.5,
    y: 446.6,
    fill: "#fff",
    opacity: 0.33
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 4.5,
    x: 675.5,
    y: 439.3,
    fill: "#fff",
    opacity: 0.33
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#0e538c",
    d: "M619.2,485.9l6.7,54.9c0.6,4.8-2.8,9.1-7.5,9.7l-74.8,9.3c-4.7,0.6-9-2.8-9.6-7.6l-6.7-54.9L619.2,485.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffbe55",
    d: "M527,494.4l1.7,14.2c1.3,10.5,10.8,18,21.2,16.7l1.6-0.2l0.9,7c0.3,2.3,2.3,3.9,4.5,3.6 c2.2-0.3,3.8-2.3,3.5-4.6l-0.9-7l36.3-4.5l0.9,7c0.3,2.3,2.3,3.9,4.5,3.6c2.2-0.3,3.8-2.3,3.5-4.6l-0.9-7l0.2,0 c10.4-1.3,17.8-10.9,16.5-21.4l-1.7-14.2l-23.9,3l-1.1-9.4c-0.5-4.1-4.2-7-8.3-6.5l-29.4,3.7c-4.1,0.5-7,4.3-6.5,8.4l1.1,9.4 L527,494.4z M598.1,525.7c-0.2-1.4,0.8-2.7,2.2-2.9c1.4-0.2,2.7,0.8,2.9,2.3c0.2,1.4-0.8,2.7-2.2,2.9 C599.5,528.2,598.2,527.2,598.1,525.7z M557.7,485.4c-0.3-2.3,1.4-4.5,3.7-4.8l20.8-2.6c2.3-0.3,4.4,1.4,4.7,3.7l0.6,5l-29.2,3.6 L557.7,485.4z M553.7,531.3c-0.2-1.4,0.8-2.7,2.2-2.9c1.4-0.2,2.7,0.8,2.9,2.3c0.2,1.4-0.8,2.7-2.2,2.9 C555.1,533.7,553.9,532.7,553.7,531.3z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#0b4870",
    d: "M391.4,585.1c-1.2-33.7-1.6-134.3,18.2-182c0,0,60.2-30.1,46.6,32.2L417.8,581c5.8,54.4-14.1,99.3-22.5,124.5 l-1,13.8l-8.1-2.9l0.1-3.9l-3.3,2.8l-26.2-9.2l3.4-3c16.5,6.7,26.2-0.7,26.2-0.7l5.1-115.5C391.5,586.3,391.4,585.8,391.4,585.1z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#dba17b",
    d: "M222.4,206.3c0,0,0.7-0.2,2.8,0.2c0-0.1,0-0.3,0-0.4c-0.1-1.8,1.5-2.5,2.1-2.5c0.6,0,5.4,2.2,5.8,2.5 c0.3,0.2,3.9,5,5.3,6.7l4,1.8l-3.9,7.9l-3-1.6l-9.9-1.2c-0.6-0.1-2.1-0.7-2.2-1.3c-0.1-0.5,0.1-1.4,0.3-1.8 c-0.9-0.2-1.6-0.6-1.7-1.4c-0.1-1.1,0.6-1.8,0.9-2c-0.8-0.3-1.4-0.8-1.5-1.5c0-0.9,0.5-1.4,0.8-1.7c-0.7-0.4-1.1-0.9-1.1-1.6 C221.1,206.8,222.4,206.3,222.4,206.3z"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#f7f7f7",
    points: "241.4 213.1 236.3 222.3 240.3 224.4 245.3 215.2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#0e538c",
    d: "M340.2 248.8C340.2 248.8 340.2 248.8 340.2 248.8l63.3 17.6c13.8 3.5 25.2 8.4 25.1 22.5-.1 11.9-10.5 24.2-24.1 19-27.3-10.6-46.4-20.6-77.4-37.3-.1 0-.1-.1-.2-.1 0 0 0 0 0 0l-88.8-46.5 5.3-10.1L340.2 248.8zM477.3 592.4c-11.2-31.7-41.4-127.6-36.6-179.2 0 0 48.5-47 54 16.5l11.2 151c16 18.3 11.4 98.7 10.9 125.3l3.2 13.5-8.6-.3-1.1-3.8-2.3 3.7-27.7-.9 2.3-3.9c17.7 1.4 24.8-8.6 24.8-8.6L478 594C477.8 593.5 477.5 593 477.3 592.4z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#ce9474",
    d: "M441.6,245.4c0,0,4,16.4,8.2,30.8L412,292.5c1.9-7.3,2.3-30.2-4.4-28.9l16.6-28.4l10.8-0.5L441.6,245.4z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#0b4870",
    d: "M470.9 404.9c.7.7 1.5 1.2 2.3 1.8 5.5 3.6 12 3.2 19.8 2.8 2.5-.1 5.1-.1 7.9-.1 10.1.3 22.2 2.3 37.2 12.3-3.5-9-14.6-18.2-26.6-26-5.8-3.9-11.8-7.3-17.3-10.3-9.4-5.2-17.3-8.7-20-9.9-.6-.3-.9-.4-.9-.4L470.9 404.9zM413.2 281c-20.5 19.1-23.3 60.3 22.7 128.5L413.2 281z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#f7f7f7",
    d: "M402.4,426.5c9.9,5.4,81.9,8.9,91.8-0.8c-5.1-53.3,0.2-90.4,3.4-115c2.9-23.7,3.8-35.9-8.5-39.7l-44.4-15 L416,286.4l-2.9-6.3C393.3,321.2,412,379.9,402.4,426.5z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M461,330.3c-5.8,23.3,6.7,48.6-9.6,68c-11.4,14.1-29.9,13.8-46.8,13.6c-0.5,5-1.1,9.8-2.1,14.5 c9.9,5.4,81.9,8.9,91.8-0.8c-5.1-53.3,0.2-90.4,3.4-115c0.8-6.2,1.4-11.6,1.7-16.3C481.2,298.8,464.8,313.6,461,330.3z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M444.7,255.9L416,286.4c0,0,12.6,16.9,15,19.3L444.7,255.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f2f2f2",
    points: "409.7 296.8 416 286.4 413.1 280.1"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#0e538c",
    d: "M453.8,360.7c22,30.8,71.6,38.2,85.8,64.9c2.1-47.7-45.5-64.8-45.5-64.8c3.1-37.7,6.7-55.8,7.8-69.7 c0.6-8.2-0.3-16.3-7.9-19.1l-49.2-16c0,0,0.4,0.6,0.4,0.8C434.3,296,434.7,334,453.8,360.7z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#0b4870",
    d: "M454,359.6c-7.6-24.8-6.1-36.8-2.1-44.9l-7.7-4l6.9-3.7c-8.3-21.7-6-47.6-5.8-50.8 C434.3,295.5,434.4,335.2,454,359.6z"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ffbe55",
    d: "M414.3,298l-1.9-4.2l3.8-5.7l3.7,5.3l-3.6,4.8c-1.1,33.3,16.7,73.3,73.9,80.8l12.3,17.4l-17.6,7.7 c-50.5-14.4-65.9-48.9-70.1-74.9l-0.1-0.3C412.1,312.7,414,300,414.3,298z"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#dba17b",
    d: "M404.7,205l-6.9,10.6l-3.5,10.7l1,2.6l-8.6,16.4l6.5,3l3.8,19.5c0,1,0.8,1.8,1.8,1.9 c6.9,0.6,27.6-0.2,32.7-19.3c4.3-16.1,5.4-24.5,5.4-24.5S435.3,210.9,404.7,205z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#0e538c",
    d: "M422.2,237.8c-4.2-1.8-5.2-10.4-5.7-17.7c-0.2-2.7-2.4-4.9-5.1-4.8l-8.4,2c-15.6,2.9-12.2-25.4,3-30 c0,0-1.4,3.1,10.8,8.8c6.2,2.9,15.9,5.2,23.1,7.1c6.9,1.8,11.2,8.7,9.9,15.8l-6.1,32.8c0,0-15.4-4.8-9.9-16.5 C439.1,223.7,423,218.6,422.2,237.8z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#dba17b",
    d: "M573,484.6c0,0-0.7-0.4-1.9-2.1c-0.1,0.1-0.2,0.2-0.3,0.3c-1.2,1.4-2.8,0.7-3.2,0.3c-0.4-0.4-2.4-5.4-2.5-5.9 c-0.1-0.4,0.5-6.3,0.8-8.5l-1.7-4.1l8.2-3l1.1,3.3l6.3,7.8c0.4,0.5,1,1.9,0.6,2.5c-0.3,0.4-1.1,0.9-1.4,1.2 c0.5,0.8,0.7,1.6,0.3,2.2c-0.6,0.9-1.7,0.9-2,0.8c0.4,0.8,0.5,1.6,0,2.1c-0.5,0.6-1.3,0.7-1.8,0.7c0.2,0.8,0.2,1.4-0.3,1.9 C574.3,485.1,573,484.6,573,484.6z"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#f7f7f7",
    points: "563.9 466.4 573.8 463.3 572.4 459.1 562.5 462.1"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#0e538c",
    d: "M480.2,280.7c8.1-8.6,24.1-10.1,30.3,3.1c12.6,26.8,19.5,47.4,30.5,81c0,0.1,0,0.1,0,0.2c0,0,0,0,0,0 l32.5,95.7l-10.7,3.5l-46.1-92.8c0,0,0-0.1,0-0.1L483,314.6C475.4,302.4,470.5,290.9,480.2,280.7z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMain);
export default __webpack_public_path__ + "static/media/main.ba72f8698e7b64bff71cfc541f512b70.svg";
export { ForwardRef as ReactComponent };